/* unplugin-vue-components disabled */import script from "./miner_history_rank.vue?vue&type=script&setup=true&lang=js"
export * from "./miner_history_rank.vue?vue&type=script&setup=true&lang=js"

import "./miner_history_rank.vue?vue&type=style&index=0&id=d80a8b34&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d80a8b34"]])

export default __exports__